import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView";
import TncView from "@/views/TncView";
import TncBgView from "@/views/TncBgView.vue";
// import SurveyView from "@/views/SurveyView.vue";
// import AboutView from "@/views/AboutView.vue";
import SurveyFormView from "@/views/SurveyFormView.vue";
import SurveyFeedbackView from "@/views/SurveyFeedbackView.vue";
import AppFeedbackView from "@/views/AppFeedbackView.vue";
import UnsubscribeView from "@/views/UnsubscribeView.vue";
import OpenAppView from "@/views/OpenAppView.vue";
import PrivacyPolicyView from "@/views/PrivacyPolicyView.vue";
import PrivacyPolicyBgView from "@/views/PrivacyPolicyBgView.vue";
import AboutView from "@/views/AboutView.vue";
import ReportView from "@/views/ReportView.vue";
import DeleteAccountView from "@/views/DeleteAccountView.vue";
import ResearchReferences from "@/views/ResearchReferences.vue";
import OrgCareView from "@/views/OrgCareView.vue";
import ZdravetoView from "@/views/ZdravetoView.vue";
// import ZdravetoInitiative2026View from "@/views/ZdravetoInitiative2026View.vue";
import TranspressInitiative2026View from "@/views/TranspressInitiative2026View.vue";
import ReportPreviewSwitchView from "@/views/ReportPreviewSwitchView.vue";
// ----- v2 redesign (2026): standalone /v2 routes are disabled; only the new
//       download page is promoted to the live /download URL. ----- //
import V2DownloadView from "@/views/v2/DownloadView.vue";
import MediaView from "@/views/MediaView.vue";
import DownloadFaqView from "@/views/DownloadFaqView.vue";
import { setLang } from "@/i18n";

const routes = [
  {
    path: "/",
    name: "root",
    redirect: "/en", // Default redirect, will be overridden by locale detection
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
  },
  {
    path: "/bg",
    name: "home-bg",
    component: HomeView,
  },
  {
    path: "/en",
    name: "home-en",
    component: HomeView,
  },
  {
    path: "/subscribe",
    redirect: "/download",
  },
  {
    path: "/account/request-delete",
    name: "request-delete",
    component: DeleteAccountView,
  },
  {
    path: "/about",
    name: "about",
    component: AboutView,
  },
  {
    path: "/survey",
    name: "survey",
    component: ReportView,
  },
  // {
  //   path: encodeURI('/проучване'),
  //   name: "survey-bg",
  //   component: SurveyView,
  // },
  {
    path: "/survey/form",
    name: "survey-form",
    component: SurveyFormView,
  },
  {
    // Customer feedback survey (opened from the email/push invite, carries ?uid=).
    path: "/survey/feedback",
    name: "survey-feedback",
    component: SurveyFeedbackView,
  },
  {
    // General app-feedback survey, linked from the "asking for feedback"
    // lifecycle emails. A response here is what tells the backend a user has
    // already given feedback, so the follow-up email skips them.
    path: "/survey/app-feedback",
    name: "survey-app-feedback",
    component: AppFeedbackView,
  },
  {
    // Unsubscribe landing page for the link in every lifecycle email footer.
    // Carries ?uid= and ?t= (HMAC) so it works with no session.
    path: "/unsubscribe",
    name: "unsubscribe",
    component: UnsubscribeView,
  },
  {
    // Deep-link hand-off for email CTAs — mail clients won't open a custom
    // momfident:// scheme directly, so they point here instead.
    path: "/open",
    name: "open-app",
    component: OpenAppView,
  },
  {
    path: "/terms-and-conditions",
    name: "tnc",
    component: TncView,
  },
  {
    path: "/bg/terms-and-conditions",
    name: "tnc-bg",
    component: TncBgView,
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: PrivacyPolicyView,
  },
  {
    path: "/bg/privacy-policy",
    name: "privacy-policy-bg",
    component: PrivacyPolicyBgView,
  },
  {
    path: "/research-references",
    name: "research-references",
    component: ResearchReferences,
  },
  {
    path: "/download",
    name: "download",
    component: V2DownloadView,
  },
  {
    path: "/en/download",
    name: "download-en",
    component: V2DownloadView,
  },
  {
    path: "/partnership",
    name: "partnership",
    alias: "/org-care-preview",
    component: OrgCareView,
  },
  {
    path: "/media",
    name: "media",
    component: MediaView,
  },
  {
    path: "/en/media",
    name: "media-en",
    component: MediaView,
  },
  {
    path: "/faq",
    name: "faq",
    component: DownloadFaqView,
  },
  {
    path: "/en/faq",
    name: "faq-en",
    component: DownloadFaqView,
  },
  // ----- Zdraveto ----- //
  // {
  //   path: "/zdraveto-ujdw2idwn21u",
  //   name: "zdraveto",
  //   component: ZdravetoView,
  // },
  {
    path: "/zdraveto-initiative-2026",
    name: "zdraveto-initiative-2026",
    component: ZdravetoView,
  },
  {
    path: "/qr/zdraveto",
    redirect: "/zdraveto-initiative-2026",
  },
  {
    path: "/initiatives/transpress-2026",
    name: "transpress",
    component: TranspressInitiative2026View,
  },
  {
    path: "/zdraveto",
    redirect: "/zdraveto-initiative-2026",
  },
  {
    path: "/report-preview",
    name: "report-preview",
    component: ReportPreviewSwitchView,
  },
  // ----- Transpress ----- //
  {
    path: "/initiatives/transpress-2026",
    name: "transpress-2026",
    component: TranspressInitiative2026View,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    window.scrollTo(0, 0);
  },
  routes,
});

// Apply language sitewide based on user preference.
// Also respect explicit locale routes (/en..., /bg...).
router.beforeEach(async (to, from, next) => {
  const preferred = window.localStorage.getItem("defaultLang") || "bg";
  const explicit =
    to.path === "/en" || to.path.startsWith("/en/") ? "en" :
      to.path === "/bg" || to.path.startsWith("/bg/") ? "bg" :
        null;

  const lang = explicit ?? preferred;
  await setLang(lang, { persist: explicit !== null });
  next();
});

export default router;
